import { addDays } from "date-fns";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { getDocumentoBlackList } from "../services/requests/creditCardRequests";
import {
  carregaCobrancas,
  carregaNegociadas,
  carregaNotificacao,
  carregaProtestadas,
  consultaNegociavelAvenida,
} from "../services/requests/getChargesInfo";
import {
  carregaParcelas,
  carregaParcelasV3,
  carregaParcelasV4,
  descontoVencimetoBoleto,
} from "../services/requests/getParcelasInfo";
import {
  carregaCredorInfo,
  carregaDevedorInfo,
  carregaFinanceiraInfo,
  carregaIP,
  carregaPrejuizoBoleto,
} from "../services/requests/getUserInfo";
import { formatCurrency } from "../utils/FormatCurrency";
import { useAuth } from "./AuthInfoContext";
import { useGeneral } from "./GeneralInfoContext";

const PrivateInfoContext = createContext({});

function PrivateInfo({ children }) {
  const assembleia_usuario = "43c419d4-8f22-4a2b-831c-41e0634266f6";
  const avenida_usuario = "a2c52c51-7c22-4f1f-bda9-e2e4a76f2567";
  const sicoob_usuario = "86bb9712-3328-4ef2-b4b6-6dac9dd61fb3";
  const provider_wlan = "d6183157-9da9-41b3-af4b-c181546f0d00";
  const provider_cref = "86643343-aa2b-4f44-a6da-cf180ecb7f02";
  const provider_crefdf = "1a597992-305e-476f-b446-abcc247475bc";
  const taxa_zoop = 2.9;
  const cobrancas_memo = useRef([]);
  //console.log(cobrancas_memo)
  const { user_id, provider_id, provider } = useAuth();
  const { avenidaDominio, today } = useGeneral();
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [credorInfo, setCredorInfo] = useState([]);
  const [devedorInfo, setDevedorInfo] = useState([]);
  const [ip, setIp] = useState("");
  const [valorOriginal, setValorOriginal] = useState(0);
  const [juros, setJuros] = useState(0);
  const [multa, setMulta] = useState(0);
  const [indice, setIndice] = useState(0);
  const [servicos, setServicos] = useState(0);
  const [valorSemTaxaProtesto, setValorSemTaxaProtesto] = useState(0);
  const [valorAPagar, setValorAPagar] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [valorTotalSemDesconto, setValorTotalSemDesconto] = useState(0);
  const [valorFeeProtesto, setValorFeeProtesto] = useState(0);
  const [valorFeeProtestoDesconto, setValorFeeProtestoDesconto] = useState(0);
  const [valorComDesconto, setValorComDesconto] = useState(0);
  const [tipoFeeProtesto, setTipoFeeProtesto] = useState("devedor");
  const [cobrancas, setCobrancas] = useState([]);
  const [countCobrancas, setCountCobrancas] = useState(0);
  const [limitCobrancas] = useState(10);
  const [pageCobrancas, setPageCobrancas] = useState(0);
  const [firstCobrancas, setFirstCobrancas] = useState(0);
  const [protestoStatus, setProtestoStatus] = useState(false);
  const [negociadas, setNegociadas] = useState([]);
  const [desconto, setDesconto] = useState(0);
  const [descontoAplicavel, setDescontoAplicavel] = useState(false);
  const [descontoMaxParcelas, setDescontoMaxParcelas] = useState(-1);
  const [descontoTipo, setDescontoTipo] = useState("");
  // const [porcentagemProtesto,setPorcentagemProtesto] = useState(0);
  const [cartaoBandeira, setCartaoBandeira] = useState(null);
  const [parcelas, setParcelas] = useState([]);
  const [boletoVencimentoParcelas, setBoletoVencimentoParcelas] = useState([]);
  const [boletoVencimentoParcelasValor, setBoletoVencimentoParcelasValor] = useState([]);
  const [boletoVencimento, setBoletoVencimento] = useState(1);
  const [parcelaValor, setParcelaValor] = useState({
    numero_parcela: 0,
    valor_parcela: 0,
  });
  const [valorAPagarDescontoParcelas, setValorAPagarDescontoParcelas] = useState(0);
  const [parcelasDescontoParcelas, setParcelasDescontoParcelas] = useState({
    numero_parcela: 0,
    valor_parcela: 0,
  });
  const [entradaAceite, setEntradaAceite] = useState(false);
  const [entradaMinima, setEntradaMinima] = useState(0);
  const [entrada, setEntrada] = useState(null);
  const [taxaPagueEntrada, setTaxaPagueEntrada] = useState(0);
  const [taxaProtestoEntrada, setTaxaProtestoEntrada] = useState(0);
  const [taxaPague, setTaxaPague] = useState(0);
  const [tipoNegociacao, setTipoNegociacao] = useState("total");
  const [travaNegociacaoTotal, setTravaNegociacaoTotal] = useState(false);
  const [taxaEnvioProtesto, setTaxaEnvioProtesto] = useState(0);
  const [tipoPagamento, setTipoPagamento] = useState();
  const [infoFinanceira, setInfoFinanceira] = useState([]);
  const [negociavelAvenida, setNegociavelAvenida] = useState(true);
  const [providerAvenida, setProviderAvenida] = useState(false);
  const [providerCREF, setProviderCREF] = useState(false);
  const [providerCREFDF, setProviderCREFDF] = useState(false);
  const [providerSicoob, setProviderSicoob] = useState(false);
  const [providerWlan, setProviderWlan] = useState(false);
  const [textoConsumidor, setTextoConsumidor] = useState(
    "Estamos aqui para lhe ajudar a quitar suas dívidas, aqui estão suas cobranças cadastradas na plataforma..."
  );
  const [protestadas, setProtestadas] = useState([]);
  const [notificacoes, setNotificacoes] = useState([]);
  const [taxaPrimeiraParcelaProtesto, setTaxaPrimeiraParcelaProtesto] = useState(false);
  const [quebrada, setQuebrada] = useState(true);
  const [oferta, setOferta] = useState([]);
  const [multaQuebrada, setMultaQuebrada] = useState(0);
  const [jurosQuebrada, setJurosQuebrada] = useState(0);
  const [valorBaixa, setValorBaixa] = useState(0);
  const [bloqueioCartao, setBloqueioCartao] = useState(true);
  const [cobrancasSelecionadas, setCobrancasSelecionadas] = useState([]);
  const [negociacaoParcial, setNegociacaoParcial] = useState(false);
  const [escolheVencimento, setEscolheVencimento] = useState(false);
  const [maxVencimento, setMaxVencimento] = useState(1);
  const [enderecoAtualizado, setEnderecoAtualizado] = useState(false);
  const geralInfoRef = useRef([]);

  //   ========= Chacagem campanha sicoob excluir após logica no banco ser concluída =======
  const [prejuizoSicoob, setPrejuizoSicoob] = useState(false);

  //   ========= Funções com interação do usuário ========

  const mudaPagina = async (event) => {
    const startIndex = parseInt(event.first);
    //  setRows(event.rows);
    setPageCobrancas(event.page);
    setFirstCobrancas(startIndex);
    // setTipoPagamento();
    // setDescontoAplicavel(false)
    const dataCobrancas = {
      provider_id: provider_id,
      user_id: user_id,
      limit: limitCobrancas,
      page: event.page,
    };
    try {
      setLoading(true);
      const data = await carregaCobrancas(dataCobrancas);
      //console.log(data)
      setCobrancas(data.cobrancas);
      const cobrancas_hist = cobrancas_memo.current;
      for (let cobranca_att of data.cobrancas) {
        const filtro_nao_repetida = cobrancas_memo.current.filter(
          (cob) => cob.cobranca_id === cobranca_att.cobranca_id
        );
        if (filtro_nao_repetida.length === 0) cobrancas_hist.push(cobranca_att);
      }
      cobrancas_memo.current = cobrancas_hist;
    } catch (error) {
      console.log(error);
      toast.error("Erro de Conexão");
    } finally {
      setLoading(false);
    }
  };

  const mudaFormaPagamento = (e) => {
    console.log(e, cartaoBandeira);
    setTipoPagamento(e);

    if (e) {
      if (cobrancas.length > 0) {
        //console.log(valorTotalSemDesconto)
        const [{ qtd_parcelas }] = cobrancas;
        let parcela = {
          valor: (valorTotalSemDesconto - (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0)).toFixed(2),
          tipo: e,
          parcelas: Number(qtd_parcelas),
          usuario_id: user_id,
          provider_id: provider_id,
          bandeira: formataCartaoBandeira(cartaoBandeira),
        };
        // console.log(tipoPagamento,
        // descontoTipo,e)
        resetaTudo();
        if (e === "C" && cartaoBandeira === null) return false;
        else {
          carregaParcelasGenerica(parcela);
          return true;
        }
      }
    }
  };

  const carregaParcelasGenerica = async (parcela) => {
    try {
      let data = [];
      if (entradaAceite && parcela.tipo === "B") {
        parcela.parcelas = 2;
        data = await carregaParcelasV4(parcela);
        wlanAdicionaEntrada(data);
      } else {
        console.log('mudaFormaPagamento::::::::', parcela)
        data = await carregaParcelas(parcela);
        setParcelas(await formataParcelas(data, parcela.tipo));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  function formataCartaoBandeira(bandeira) {
    switch (bandeira) {
      case "mastercard":
        return "mastercard";
      case "elo":
        return "elo";
      case "visa":
        return "visa";
      case "dinersclub":
        return "diners";
      case "discover":
        return "discover";
      case "hipercard":
        return "hipercard";
      case "jcb":
        return "jcb";
      case "amex":
        return "american-express";
      default:
        return null;
    }
  }

  //------------ FUNÇÃO LEGADO - Usada para a Visão antigamente talvez volte para entrada inputável -----------------

  const adicionaEntrada = async (e) => {
    if (cobrancas.length > 0) {
      const [{ qtd_parcelas }] = cobrancas;
      let entradaAtual = entrada;
      if (e !== "botao") entradaAtual = e;
      //console.log(entradaAtual)

      const parcela = {
        valor:
          descontoTipo === "tempo" && e === "B"
            ? valorTotalSemDesconto - entradaAtual
            : valorComDesconto - entradaAtual,
        tipo: tipoPagamento,
        parcelas: Number(qtd_parcelas),
        usuario_id: user_id,
        provider_id: provider_id,
      };
      setParcelaValor({ numero_parcela: 0, valor_parcela: 0 });
      setParcelas([]);
      if (entradaAtual > 0 || entradaAtual !== null) setTaxaPagueEntrada((entradaAtual + 2.9) / 0.99 - entradaAtual);
      else setTaxaPagueEntrada(0);
      setValorAPagarDescontoParcelas(0);
      setParcelasDescontoParcelas({ numero_parcela: 0, valor_parcela: 0 });
      setDescontoAplicavel(false);
      try {
        console.log("----LEGADO-----");
        const data = await carregaParcelas(parcela);
        setParcelas(formataParcelas(data, tipoPagamento));
      } catch (error) {
        console.log(error);
      }
    }
  };

  const limpaEntrada = () => {
    setEntrada(null);
    mudaFormaPagamento("B");
    setTaxaPagueEntrada(0);
  };

  //---------------------------------------------------------------------------------------//

  const resetaTudo = () => {
    setParcelasDescontoParcelas({ numero_parcela: 0, valor_parcela: 0 });
    setParcelaValor({ numero_parcela: 0, valor_parcela: 0 });
    setParcelas([]);
    setBoletoVencimentoParcelasValor([]);
    setValorAPagarDescontoParcelas(0);
    setEntrada(null);
    setTaxaPagueEntrada(0);
    setDescontoAplicavel(false);
    //setDesconto(0);
  };

  const checaDesconto = async (e) => {
    //console.log(e,descontoMaxParcelas);
    setParcelaValor(e);
    if (provider_id === avenida_usuario) {
      setEntrada(e.valor_primeira_parcela);
      const valor_pagamento =
        Number(e.valor_primeira_parcela) + Number(e.valor_parcela) * (Number(e.numero_parcela) - 1);
      setDesconto(valorTotal - Number(valor_pagamento));
      // console.log(valorTotal-Number(valor_pagamento))
      setEntradaAceite(true);
    }
    if (entradaAceite && tipoPagamento === "B") {
      setEntrada(e.valor_primeira_parcela);
      //const valor_pagamento = Number(e.valor_primeira_parcela)+(Number(e.valor_parcela)*(Number(e.numero_parcela)-1))
      // setDesconto(valorTotal-Number(valor_pagamento))
      // console.log(valorTotal-Number(valor_pagamento))
      //setEntradaAceite(true)
      setTaxaProtestoEntrada(e.valor_protesto_entrada);
    }
    const desconto_aplicavel =
      (Number(e.numero_parcela) <= descontoMaxParcelas &&
        ((tipoPagamento === "B" && descontoTipo === "boleto") ||
          descontoTipo === "parcela" ||
          descontoTipo === "tempo" ||
          descontoTipo === "porcento")) ||
      provider_id === avenida_usuario
        ? true
        : false;
    //console.log('desconto aplicavel:::::',descontoAplicavel)
    if (!desconto_aplicavel) setBoletoVencimento(1);
    else setParcelasDescontoParcelas(e);
    if (descontoAplicavel && descontoTipo === "boleto")
      setBoletoVencimento(Number(boletoVencimentoParcelasValor.dia_final));
    if (descontoTipo === "parcela") await checaParcelasV3(e);

    aplicaDesconto(desconto_aplicavel);
    setDescontoAplicavel(desconto_aplicavel);
  };

  const checaDescontoBoleto = async (e) => {
    const desconto_aplicavel = true;
    setBoletoVencimento(Number(e.dia_final));
    await checaParcelasV3(e);
    aplicaDesconto(desconto_aplicavel);
    setDescontoAplicavel(desconto_aplicavel);
  };

  const aplicaDesconto = (e) => {
    if (e && provider_id !== avenida_usuario) {
      // console.log(valorSemTaxaProtesto, desconto)
      if (tipoFeeProtesto === "credor" || tipoFeeProtesto === "nenhum") {
        if (descontoTipo === "tempo" || descontoTipo === "porcento")
          //setDesconto(geralInfoRef.current.infoCobrancas.desconto_total)
          setServicos(0);
        setValorAPagar(valorSemTaxaProtesto - desconto);
        console.log("Valor a Pagar :::", valorSemTaxaProtesto - desconto);
      } else {
        //setDesconto(geralInfoRef.current.infoCobrancas.desconto_total)
        if (descontoTipo === "tempo" || descontoTipo === "porcento") {
          console.log("Desconto:::", desconto);
          //setServicos(valorTotalSemDesconto - valorOriginal - juros - multa - indice);
        }
        if (descontoTipo !== "boleto" || descontoTipo !== "porcento")
          // console.log(desconto,valorSemTaxaProtesto,valorFeeProtestoDesconto)
          setValorAPagar(valorSemTaxaProtesto - desconto + valorFeeProtestoDesconto);
        console.log("Valor a Pagar :::", valorSemTaxaProtesto - desconto + valorFeeProtestoDesconto);
        console.table({
          valorSemTaxaProtesto,
          desconto,
          valorFeeProtestoDesconto,
        });
      }
    } else {
      if (tipoFeeProtesto === "credor" || tipoFeeProtesto === "nenhum") setServicos(0);
      else {
        if (quebrada) {
          //setServicos(valorTotalSemDesconto - valorOriginal - juros - multa - indice);
          console.table({
            total: valorTotalSemDesconto,
            original_total: valorOriginal,
            valor_juros: juros,
            multa_total: multa,
          });
        } else {
          //setServicos(valorFeeProtesto);
          console.table({
            total: valorTotal,
            original_total: valorOriginal,
            valor_juros: juros,
            multa_total: multa,
          });
        }
      }
      setValorAPagar(valorTotalSemDesconto);
    }
  };

  const checaParcelasV3 = async (e) => {
    let parcelaV3 = [];
    //console.log(e)
    if (descontoTipo === "boleto") {
      parcelaV3 = {
        valor: valorTotalSemDesconto,
        tipo: tipoPagamento,
        parcelas: e.dia_final,
        usuario_id: user_id,
        provider_id: provider_id,
        bandeira: "visa",
      };
      setLoading(true);
      setBoletoVencimentoParcelasValor(e);
    }
    if (descontoTipo === "parcela") {
      parcelaV3 = {
        valor: valorTotalSemDesconto,
        tipo: tipoPagamento,
        parcelas: e.numero_parcela,
        usuario_id: user_id,
        provider_id: provider_id,
        bandeira: formataCartaoBandeira(cartaoBandeira),
      };
      setLoading(true);
    }
    try {
      let data = [];
      //console.log(geralInfo)
      //if (provider_id === "86bb9712-3328-4ef2-b4b6-6dac9dd61fb3") {
      if (geralInfoRef.current.infoCobrancas.parametrosCobrancaDesconto.desconto_tipo === "multipo") {
        data = await carregaParcelasV4(parcelaV3);
        setDesconto(
          valorTotalSemDesconto -
            (data[0].valor_parcela * data[0].numero_parcela - data[0].valor_fee_pague * data[0].numero_parcela)
        );
        setValorAPagarDescontoParcelas(data[0].valor_parcela * data[0].numero_parcela);
        setParcelasDescontoParcelas(data[0]);
        setValorFeeProtestoDesconto(data[0].valor_fee_protesto * data[0].numero_parcela);
        setValorComDesconto(
          Number(data[0].valor_parcela) * Number(data[0].numero_parcela) -
            Number(data[0].valor_fee_pague * data[0].numero_parcela)
        );
      } else {
        data = await carregaParcelasV3(parcelaV3);
        //console.log(data, valorTotalSemDesconto)
        setDesconto(valorTotalSemDesconto - (data[0].valor_parcela * data[0].numero_parcela - data[0].valor_fee_pague));
        setValorAPagarDescontoParcelas(data[0].valor_parcela * data[0].numero_parcela);
        setParcelasDescontoParcelas(data[0]);
        setValorFeeProtestoDesconto(data[0].valor_fee_protesto);
        setValorComDesconto(
          Number(data[0].valor_parcela) * Number(data[0].numero_parcela) - Number(data[0].valor_fee_pague)
        );
        //console.log((Number(data[0].valor_parcela)*Number(data[0].numero_parcela)) - Number(data[0].valor_fee_pague))
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const wlanAdicionaEntrada = async (data) => {
    setParcelas(await formataParcelas(data, "B"));
    //setEntrada(Number(data[0].valor_parcela))
    //setTaxaPagueEntrada(Number(data[0].valor_fee_protesto))
  };

  const precarregaAvenidaParcelas = async (e) => {
    // if(provider_id === provider_wlan){
    //   const data = await carregaParcelasV4({
    //     valor:e.total,
    //     tipo:"B",
    //     parcelas:'2',
    //     usuario_id:user_id,
    //     provider_id:provider_id,
    //     entrada: 0,
    //   })
    //   wlanAdicionaEntrada(data)
    // }

    const data = await carregaParcelas({
      valor: e.total,
      tipo: "B",
      parcelas: e.cobrancas[0].qtd_parcelas,
      usuario_id: user_id,
      provider_id: provider_id,
    });
    //setEntrada(Number(data[0].valor_primeira_parcela))
    setParcelas(await formataParcelas(data, "B"));

    setTipoPagamento("B");
  };

  const mensagemConsumidor = (e) => {
    if (e === avenida_usuario)
      setTextoConsumidor(
        "Que bom que você chegou até aqui, temos uma excelente oferta para você. Não perca essa oportunidade!"
      );
    else
      setTextoConsumidor(
        `Nesta página você negocia seus débitos com a(o) ${provider}, cadastrados em nossa plataforma.`
      );
  };

  //   ============ Função a ser executada quando a página é renderizada ==========

  function processaInfo() {
    const geralInfo = geralInfoRef.current;
    setBoletoVencimento(1);
    const { infoCredor, infoDevedor, infoCobrancas, infoNegociadas, infoProtestadas, infoNotificacao } = geralInfo;

    if (infoProtestadas.length > 0) {
      setProtestoStatus(true);
      setProtestadas(infoProtestadas);
    } else {
      setProtestoStatus(false);
      setProtestadas([]);
    }

    // console.log(descontoValor)
    //const feeProtesto = maiorTaxaProtesto(infoCobrancas.cobrancas);
    let protesto_taxa_envio = infoCobrancas.valor_protesto_taxa_envio;
    let valorSemTaxa = infoCobrancas.total + infoCobrancas.desconto_total - infoCobrancas.valor_fee_s_desconto;
    let tipo_fee = "devedor";
    setMaxVencimento(addDays(today, Number(infoCobrancas.parametrosCobrancaDesconto.pcc_maximo_boleto_vencimento)));
    setEscolheVencimento(Number(infoCobrancas.parametrosCobrancaDesconto.pcc_maximo_boleto_vencimento) > 1);
    if (infoCredor.usuario_id === sicoob_usuario) setDescontoTipo("parcela");
    else setDescontoTipo(infoCobrancas.parametrosCobrancaDesconto.desconto_tipo);
    if (infoCobrancas.cobrancas.length > 0) {
      tipo_fee = infoCobrancas.cobrancas[0].tipo_cobranca_fee;
      setPrejuizoSicoob(infoCobrancas.cobrancas[0].cobranca_descricao.includes("PREJUIZO"));
      setTipoFeeProtesto(tipo_fee);
      setEntradaAceite(infoCobrancas.cobrancas[0].pcc_entrada === true);
      const entrada_minima =
        (infoCobrancas.cobrancas[0].pcc_entrada_porcentagem * (infoCobrancas.total - infoCobrancas.desconto_total)) /
        100;
      setEntradaMinima(entrada_minima);
      //console.log(infoCobrancas)
    }
    setTaxaPrimeiraParcelaProtesto(infoCobrancas.parametrosCobrancaDesconto.protesto_primeira_parcela);
    //setPorcentagemProtesto(feeProtesto);
    setValorBaixa(infoCobrancas.valor_baixa);
    setValorOriginal(infoCobrancas.original_total);
    setMulta(infoCobrancas.multa_total);
    setJuros(infoCobrancas.valor_juros);
    setIndice(infoCobrancas.valor_indice);
    setDesconto(
      infoCobrancas.desconto_total + (infoCobrancas.valor_fee_s_desconto - infoCobrancas.valor_fee_c_desconto)
    );
    setDescontoMaxParcelas(
      Number(infoCobrancas.parametrosCobrancaDesconto.desconto_qtd_parcelas)
        ? Number(infoCobrancas.parametrosCobrancaDesconto.desconto_qtd_parcelas)
        : -1
    );
    setValorTotalSemDesconto(infoCobrancas.total + infoCobrancas.desconto_total);
    setValorFeeProtesto(infoCobrancas.valor_fee_s_desconto);
    setValorFeeProtestoDesconto(infoCobrancas.valor_fee_c_desconto);
    setValorTotal(infoCobrancas.total);
    setValorSemTaxaProtesto(infoCobrancas.total + infoCobrancas.desconto_total - infoCobrancas.valor_fee_s_desconto);
    let quebrada = [];
    if (infoCobrancas.cobrancas.length > 0) {
      setTaxaEnvioProtesto(protesto_taxa_envio);
      if (protesto_taxa_envio > 0) setProtestoStatus(true);
      quebrada = infoCobrancas.cobrancas.filter((quebradas) => quebradas.negociacao_quebrada_id !== null);
      if (quebrada.length > 0) {
        setQuebrada(true);
        // if(infoCredor.usuario_id !== provider_cref){
        //   setDescontoMaxParcelas(-1)
        // }
      } else {
        setQuebrada(false);
      }
    }
    setNegociacaoParcial(infoCobrancas.parametrosCobrancaDesconto.pcc_negociacao_parcial);

    if (tipo_fee === "credor" || tipo_fee === "nenhum") {
      valorSemTaxa = infoCobrancas.total;
      setServicos(0);
      setValorAPagar(infoCobrancas.total);
      setValorComDesconto(valorSemTaxa);
    } else {
      console.table({
        valorSemTaxa,
        desconto: infoCobrancas.desconto_total,
        fee: infoCobrancas.valor_fee_c_desconto,
      });
      setValorComDesconto(valorSemTaxa - infoCobrancas.desconto_total + infoCobrancas.valor_fee_c_desconto);
      if (quebrada.length > 0) {
        console.table({
          total: infoCobrancas.total,
          original_total: infoCobrancas.original_total,
          valor_juros: infoCobrancas.valor_juros,
          multa_total: infoCobrancas.multa_total,
        });
        setServicos(
          infoCobrancas.total - infoCobrancas.original_total - infoCobrancas.valor_juros - infoCobrancas.multa_total
        );
      } else {
        setServicos(infoCobrancas.valor_fee_s_desconto);
      }
      setValorAPagar(infoCobrancas.total);
    }

    setCountCobrancas(infoCobrancas.count);
    //setProtestoStatus(checaProtesto(infoCobrancas.cobrancas));
    const negociadasVerdadeiras = infoNegociadas.filter(
      (
        negociadasData //Filtro adicionado para não exibir pais sem boleto ou cartão
      ) => negociadasData.boletos.length > 0 || negociadasData.cartaos.length > 0
    );
    setNegociadas(negociadasVerdadeiras.reverse());

    setTipoPagamento();
    setParcelaValor({ numero_parcela: 0, valor_parcela: 0 });
    setParcelas([]);
    setEntrada(null);

    setCredorInfo(infoCredor);
    setDevedorInfo(infoDevedor);
    setMultaQuebrada(Number(infoCobrancas.parametrosCobrancaDesconto.pcc_multa_quebrada));
    setJurosQuebrada(Number(infoCobrancas.parametrosCobrancaDesconto.pcc_juros_quebrada));

    // console.log('INFO DEVEDOR', infoDevedor)
    // console.log('Cobranças', infoCobrancas.cobrancas)

    //   cobranca.quebradas = quebradaDetalhe
    //   return cobranca
    // })

    // console.log('DETALHES :::::', detalhes)
  }

  //  ========= Funções de cálculo e formatação de variáveis ========

  async function formataParcelas(parcela, tipo) {
    //console.log(parcela)
    // const valorComDesconto = (valorSemTaxaProtesto-desconto+valorFeeProtestoDesconto)
    let parcelasComDesconto = [];

    if ((descontoTipo === "porcento" || descontoTipo === "tempo") && !entradaAceite) {
      console.log("-----Formata Parcelas-----", valorComDesconto);
      parcelasComDesconto = await carregaParcelas({
        valor: (valorComDesconto - (taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0)).toFixed(2) - entrada,
        tipo: tipo,
        parcelas: Number(descontoMaxParcelas),
        usuario_id: user_id,
        provider_id: provider_id,
        bandeira: formataCartaoBandeira(cartaoBandeira),
      });
    }

    // console.log(parcelasComDesconto, parcela)

    let ajust = parcela.map((item) => {
      if (parcelasComDesconto[Number(item.numero_parcela) - 1])
        return {
          numero_parcela: item.numero_parcela,
          valor_parcela:
            Number(item.numero_parcela) <= descontoMaxParcelas &&
            (descontoTipo === "porcento" || descontoTipo === "tempo") &&
            !entradaAceite
              ? parcelasComDesconto[Number(item.numero_parcela) - 1].valor_parcela
              : Number(item.valor_parcela),
          uuid: item.uuid,
        };
      else return parcela[Number(item.numero_parcela) - 1];
    });

    // console.log(ajust, parcela)

    let data = [];
    //console.log(parcela,parcelasComDesconto,Number(parcela[0].numero_parcela),valorComDesconto)
    if (descontoTipo === "parcela") {
      data = ajust.map((parcela) => ({
        label: `${parcela.numero_parcela}x de 
      `,
        values: {
          numero_parcela: parcela.numero_parcela,
          valor_parcela: Number(parcela.valor_parcela).toFixed(2),
        },
      }));
    } else if (provider_id === avenida_usuario)
      data = parcela.map((parcela) => ({
        label:
          Number(parcela.numero_parcela) > 1
            ? `${parcela.numero_parcela - 1}x de ${formatCurrency(parcela.valor_parcela)}`
            : "Parcela Única",
        values: {
          numero_parcela: parcela.numero_parcela,
          valor_primeira_parcela: parcela.valor_primeira_parcela,
          valor_parcela: Number(parcela.valor_parcela).toFixed(2),
        },
      }));
    else if (entradaAceite && tipo === "B") {
      const valor_entrada = parcela[0].valor_parcela;
      const valor_protesto_entrada = parcela[0].valor_fee_protesto;
      parcela.splice(0, 1);
      data = parcela.map((parcela) => ({
        label:
          Number(parcela.numero_parcela) > 1
            ? `Entrada + ${parcela.numero_parcela - 1}x de ${formatCurrency(parcela.valor_parcela)}`
            : `1x de ${formatCurrency(parcela.valor_parcela)}`,
        values: {
          numero_parcela: parcela.numero_parcela,
          valor_primeira_parcela: Number(parcela.numero_parcela) > 1 ? valor_entrada : 0,
          valor_parcela: Number(parcela.valor_parcela).toFixed(2),
          valor_protesto_entrada: Number(parcela.numero_parcela) > 1 ? valor_protesto_entrada : 0,
        },
      }));
      //console.log(parcela)
    } else
      data = ajust.map((parcela) => ({
        label: `${parcela.numero_parcela}x de ${formatCurrency(parcela.valor_parcela)}`,
        values: {
          numero_parcela: parcela.numero_parcela,
          valor_parcela: Number(parcela.valor_parcela).toFixed(2),
        },
      }));

    return data;
  }

  function formataDescontoVencimentoParcelas(descontoData) {
    const data = descontoData.map((descontoData) => ({
      label: `Vence em: ${descontoData.dia_final} dias, Desconto de: ${Number(descontoData.valor_desconto)}%`,
      values: {
        desconto_data: descontoData.valor_desconto,
        dia_inicial: descontoData.dia_inicial,
        dia_final: descontoData.dia_final,
      },
    }));

    return data;
  }

  function checaProtesto(cobrancas) {
    const cobrancasProtestadas = cobrancas.filter((item) => item.protesto_status === "ENVIADO");
    console.log("PROTESTO:", cobrancasProtestadas);
    if (cobrancasProtestadas.length > 0) setProtestoStatus(true);
    else setProtestoStatus(false);
    return cobrancasProtestadas.length > 0 ? true : false;
  }

  function valoresNegociacaoParcial(cobrancas_array) {
    if (cobrancas_array.length > 0) {
      //console.log(cobrancas_array[0].valor_original)
      const valor_parcial_original = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_original);
      }, 0);
      const valor_parcial_juros = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_juros);
      }, 0);
      const valor_parcial_multa = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_multa);
      }, 0);
      const valor_parcial_indice = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_indice);
      }, 0);
      const valor_parcial_corrigido = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_sem_fee_protesto);
      }, 0);
      const valor_parcial_corrigido_com_desconto = cobrancas_array.reduce((acc, curr) => {
        return acc + (Number(curr.valor_sem_fee_protesto) - Number(curr.desconto_total));
      }, 0);
      const valor_parcial_fee_protesto = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_fee_protesto);
      }, 0);
      const valor_parcial_fee_protesto_desc = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_fee_protesto_desconto);
      }, 0);
      const valor_parcial_total_sem_desc = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.valor_pagamento_sem_desconto);
      }, 0);
      const valor_parcial_total_com_desc = cobrancas_array.reduce((acc, curr) => {
        if (curr.negociacao_quebrada_id)
          return (
            acc +
            (Number(curr.valor_para_pagamento) - Number(curr.desconto_total) + Number(curr.valor_fee_protesto_desconto))
          );
        else
          return (
            acc +
            (Number(curr.valor_pagamento_com_desconto) -
              (Number(curr.valor_fee_protesto) - Number(curr.valor_fee_protesto_desconto)))
          );
      }, 0);
      const valor_parcial_desconto = cobrancas_array.reduce((acc, curr) => {
        return (
          acc +
          Number(curr.desconto_total) +
          (Number(curr.valor_fee_protesto) - Number(curr.valor_fee_protesto_desconto))
        );
      }, 0);
      const valor_parcial_baixa = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.baixa_manual);
      }, 0);
      const valor_parcial_envio_protesto = cobrancas_array.reduce((acc, curr) => {
        return acc + Number(curr.protesto_taxa_envio);
      }, 0);

      setValorSemTaxaProtesto(valor_parcial_corrigido);
      //setPorcentagemProtesto(feeProtesto);
      setValorBaixa(valor_parcial_baixa);
      setValorOriginal(valor_parcial_original);
      setMulta(valor_parcial_multa);
      setJuros(valor_parcial_juros);
      setIndice(valor_parcial_indice);
      setDesconto(valor_parcial_desconto);
      setValorTotalSemDesconto(valor_parcial_total_sem_desc);
      setValorFeeProtesto(valor_parcial_fee_protesto);
      setValorFeeProtestoDesconto(valor_parcial_fee_protesto_desc);
      setValorTotal(valor_parcial_total_com_desc);
      setTaxaEnvioProtesto(valor_parcial_envio_protesto);
      console.log(valor_parcial_total_com_desc);

      if (tipoFeeProtesto === "credor" || tipoFeeProtesto === "nenhum") {
        setServicos(0);
        setValorAPagar(valor_parcial_corrigido);
        setValorComDesconto(valor_parcial_corrigido_com_desconto);
      } else {
        //console.table({valorSemTaxa,desconto:infoCobrancas.desconto_total,fee:infoCobrancas.valor_fee_c_desconto})
        if (quebrada) {
          const fee_aparente_quebrada =
            valor_parcial_total_sem_desc - valor_parcial_original - valor_parcial_juros - valor_parcial_multa;
          setValorComDesconto(
            valor_parcial_corrigido_com_desconto +
              fee_aparente_quebrada -
              (valor_parcial_fee_protesto - valor_parcial_fee_protesto_desc)
          );
          console.table({
            fee_aparente_quebrada,
            valor_parcial_corrigido_com_desconto: valor_parcial_corrigido_com_desconto,
            total_com_desc: valor_parcial_total_com_desc,
            total: valor_parcial_total_sem_desc,
            original_total: valor_parcial_original,
            valor_juros: valor_parcial_juros,
            multa_total: valor_parcial_multa,
          });
          setServicos(fee_aparente_quebrada);
        } else {
          setServicos(valor_parcial_fee_protesto);
          setValorComDesconto(valor_parcial_total_com_desc);
        }
        setValorAPagar(valor_parcial_total_sem_desc);
      }
      setParcelaValor({ numero_parcela: 0, valor_parcela: 0 });
      setParcelas([]);
      // console.table({
      //   valor_parcial_original,
      //   valor_parcial_juros,
      //   valor_parcial_multa,
      //   valor_parcial_indice,
      //   valor_parcial_corrigido,
      //   valor_parcial_corrigido_com_desconto,
      //   valor_parcial_fee_protesto,
      //   valor_parcial_fee_protesto_desc,
      //   valor_parcial_total_sem_desc,
      //   valor_parcial_total_com_desc,
      //   valor_parcial_desconto,
      //   valor_parcial_baixa
      // })
    } else {
      setValorSemTaxaProtesto(0);
      //setPorcentagemProtesto(feeProtesto);
      setValorBaixa(0);
      setValorOriginal(0);
      setMulta(0);
      setJuros(0);
      setIndice(0);
      setDesconto(0);
      setValorTotalSemDesconto(0);
      setValorFeeProtesto(0);
      setValorFeeProtestoDesconto(0);
      setValorTotal(0);

      if (tipoFeeProtesto === "credor" || tipoFeeProtesto === "nenhum") {
        setServicos(0);
        setValorAPagar(0);
        setValorComDesconto(0);
      } else {
        //console.table({valorSemTaxa,desconto:infoCobrancas.desconto_total,fee:infoCobrancas.valor_fee_c_desconto})
        setValorComDesconto(0);
        if (quebrada.length > 0) {
          setServicos(0);
        } else {
          setServicos(0);
        }
        setValorAPagar(0);
      }
      setParcelaValor({ numero_parcela: 0, valor_parcela: 0 });
      setParcelas([]);
    }
  }

  // =========== Função que se comunica com o back, logo após a página ser renderizada ========

  useEffect(() => {
    async function carregaInfoPrivada() {
      const dataCobrancas = {
        provider_id: provider_id,
        user_id: user_id,
        limit: limitCobrancas,
        page: pageCobrancas,
      };
      const dataNegociadas = { user_id: user_id, provider_id: provider_id };
      setLoading(true);
      try {
        const infoDevedor = await carregaDevedorInfo(user_id);

        const infoCredor = await carregaCredorInfo(provider_id);
        setProviderAvenida(provider_id === avenida_usuario);
        setProviderSicoob(provider_id === sicoob_usuario);
        setProviderWlan(provider_id === provider_wlan);
        setProviderCREF(provider_id === provider_cref);
        setProviderCREFDF(provider_id === provider_crefdf);
        mensagemConsumidor(provider_id);
        if (infoCredor.cartorio_provider === true) window.location.replace("https://protesto.paguedireto.com.br");

        const ip = await carregaIP();
        setIp(ip.ip);
        const infoCobrancas = await carregaCobrancas(dataCobrancas);
        const infoNegociadas = await carregaNegociadas(dataNegociadas);

        const negociacoesProtestadas = await carregaProtestadas({
          usuario_documento: infoDevedor.usuario_documento,
          provider_id: provider_id,
        });

        const notificacao = await carregaNotificacao({
          provider_id: provider_id,
        });

        const notificacaoLista = Array.isArray(notificacao)
          ? notificacao.filter((item) => item && Object.keys(item).length > 0)
          : notificacao && Object.keys(notificacao).length > 0
            ? [notificacao]
            : [];

        setNotificacoes(notificacaoLista);

        infoNegociadas.map((curr, index) => {
          if (curr.boletos.length > 0) {
            infoNegociadas[index].valor_pago = curr.boletos
              .filter((e) => e.boleto_status === "true")
              .reduce((acc, e) => {
                return acc + e.boleto_valor;
              }, 0);
          } else if (curr.cartaos.length > 0) {
            infoNegociadas[index].valor_pago =
              curr?.cartaos[0]?.cartao_status === "paid" ? curr.cartaos[0].cartao_valor : 0;
          }
        });

        const usuario_cartao_bloqueado = await getDocumentoBlackList(infoDevedor.usuario_documento);
        setBloqueioCartao(usuario_cartao_bloqueado.resultado === 1);

        // if (negociacoesProtestadas.length > 0){
        //   setProtestadas(negociacoesProtestadas)
        // }
        // else
        //   setProtestadas([])
        if(infoDevedor?.enderecos.length > 0){
          const endereco_atual = infoDevedor.enderecos[0]
          if(
             endereco_atual.endereco_cep &&
             endereco_atual.endereco_estado &&
             endereco_atual.endereco_cidade &&
             endereco_atual.endereco_rua &&
             endereco_atual.endereco_numero &&
             endereco_atual.endereco_bairro
          ){
            setEnderecoAtualizado(true)
          } else 
            setEnderecoAtualizado(false)
        } else {
          setEnderecoAtualizado(false)
        }

        const geralInfo = {
          infoCredor: infoCredor,
          infoDevedor: infoDevedor,
          infoCobrancas: infoCobrancas,
          infoNegociadas: infoNegociadas,
          infoProtestadas: negociacoesProtestadas,
          infoNotificacao: notificacao,
        };
        geralInfoRef.current = geralInfo;
        cobrancas_memo.current = infoCobrancas.cobrancas;
        setCobrancas(infoCobrancas.cobrancas);

        processaInfo();

        const indisponiveis_parcial = infoCobrancas.cobrancas.filter((e) => !e.disponivel_parcial);

        if (indisponiveis_parcial.length > 0 && infoCobrancas.parametrosCobrancaDesconto.pcc_negociacao_parcial) {
          setTravaNegociacaoTotal(true);
          valoresNegociacaoParcial([]);
          setTipoNegociacao("parcial");
        }

        if (infoNegociadas.length === 0 && provider_id === avenida_usuario) {
          await carregaAvenidaInfo();
        }
        //console.log(provider_id === provider_wlan, infoCobrancas.cobrancas.length)
        if (avenidaDominio && infoCobrancas.cobrancas.length > 0) {
          await precarregaAvenidaParcelas(infoCobrancas);
        }

        if (provider_id === sicoob_usuario) {
          await carregaSicoobPrejuízo();
        }

        const info_financeira = await carregaFinanceiraInfo(provider_id);
        setBloqueioCartao(true);
        //console.log('bloqueado')
        if (info_financeira.length > 0)
          for (let financeira_atual of info_financeira) {
            if (financeira_atual.tipo_pagamento_descricao === "cartao" && financeira_atual.situacao === "aprovado") {
              setBloqueioCartao(false);
              console.log("desbloqueado", financeira_atual);
            }
          }

        setInfoFinanceira(info_financeira);
      } catch (error) {
        console.log(error);
        toast.error("Erro ao carregar informações de Usuário");
      } finally {
        setLoading(false);
      }
    }
    async function carregaInfoVencimentoDesconto() {
      const descontoVencimentoData = await descontoVencimetoBoleto(provider_id);
      if (descontoVencimentoData.length > 0) {
        setBoletoVencimentoParcelas(formataDescontoVencimentoParcelas(descontoVencimentoData));
      } else setBoletoVencimentoParcelas([]);
    }
    async function carregaAvenidaInfo() {
      try {
        const avenidaNegociavelInfo = await consultaNegociavelAvenida(user_id);
        setNegociavelAvenida(avenidaNegociavelInfo.dividaAvenidaStatus);
      } catch (error) {
        console.log(error);
        setNegociavelAvenida(error.response.data.dividaAvenidaStatus);
      }
    }

    async function carregaSicoobPrejuízo() {
      try {
        const data = await carregaPrejuizoBoleto({
          provider_id,
          usuario_id: user_id,
        });
        setOferta(data);
      } catch (error) {
        console.log(error);
        if (error.response === undefined) toast.error("Erro de conexão com o servidor");
        if (error.response.status === 500) toast.error("Erro de conexão com o servidor");
      }
    }

    if (provider_id) {
      carregaInfoPrivada();
      carregaInfoVencimentoDesconto();
      //if(avenidaDominio)
      // carregaParcelas('B')
    }
  }, [reload]);

  return (
    <PrivateInfoContext.Provider
      value={{
        processaInfo,
        setReload,
        ip,
        loading,
        setLoading,
        credorInfo,
        devedorInfo,
        valorOriginal,
        juros,
        multa,
        indice,
        valorBaixa,
        servicos,
        desconto,
        descontoTipo,
        descontoAplicavel,
        setDescontoAplicavel,
        descontoMaxParcelas,
        valorTotal,
        valorAPagar,
        valorSemTaxaProtesto,
        valorComDesconto,
        taxa_zoop,
        cobrancas,
        countCobrancas,
        pageCobrancas,
        firstCobrancas,
        tipoFeeProtesto,
        valorFeeProtesto,
        valorFeeProtestoDesconto,
        protestoStatus,
        mudaPagina,
        negociadas,
        parcelas,
        parcelaValor,
        valorAPagarDescontoParcelas,
        parcelasDescontoParcelas,
        boletoVencimento,
        setBoletoVencimento,
        boletoVencimentoParcelas,
        boletoVencimentoParcelasValor,
        tipoPagamento,
        entradaAceite,
        entradaMinima,
        entrada,
        taxaProtestoEntrada,
        taxaPagueEntrada,
        taxaPague,
        setTaxaPague,
        taxaEnvioProtesto,
        infoFinanceira,
        oferta,
        setEntrada,
        cartaoBandeira,
        setCartaoBandeira,
        adicionaEntrada,
        checaParcelasV3,
        checaDescontoBoleto,
        checaDesconto,
        aplicaDesconto,
        limpaEntrada,
        mudaFormaPagamento,
        formataCartaoBandeira,
        protestadas,
        notificacoes,
        quebrada,
        multaQuebrada,
        jurosQuebrada,
        prejuizoSicoob,
        providerSicoob,
        negociavelAvenida,
        assembleia_usuario,
        providerAvenida,
        providerWlan,
        providerCREF,
        providerCREFDF,
        taxaPrimeiraParcelaProtesto,
        valorTotalSemDesconto,
        textoConsumidor,
        bloqueioCartao,
        cobrancas_memo,
        cobrancasSelecionadas,
        setCobrancasSelecionadas,
        valoresNegociacaoParcial,
        tipoNegociacao,
        setTipoNegociacao,
        travaNegociacaoTotal,
        negociacaoParcial,
        checaProtesto,
        escolheVencimento,
        maxVencimento,
        enderecoAtualizado
      }}
    >
      {children}
    </PrivateInfoContext.Provider>
  );
}

function usePrivate() {
  const context = useContext(PrivateInfoContext);
  return context;
}

export { PrivateInfo, usePrivate };
